.card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  padding: 20px;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-dialog);
}

.check {
  width: 44px;
  height: 44px;
  border: var(--outline);
  border-radius: 999px;
  background: var(--done);
}

.title {
  font-size: 24px;
}

.text {
  line-height: 1.55;
  color: var(--ink-2);
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.primary {
  display: inline-flex;
  align-items: center;
  min-height: 48px;
  padding: 0 18px;
  border: var(--outline);
  border-radius: var(--radius-control);
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  background: var(--accent);
  color: var(--accent-ink);
  box-shadow: var(--shadow-button);
}
